import React, { Component } from "react";

export default class LinkHitory extends Component {

    constructor(props) {
        super(props)
    }

    render() {
        var yt_id        = this.props.yt_id;
        var exercise_id  = this.props.exercise_id;
        var title        = this.props.title;
        var week_tracker = this.props.week_tracker;
        var program_id   = this.props.program_id;
        var font_color   = this.props.font_color;

        return (<span className = "workoutDetailsHistoryLabel workoutDetailHistoryProductTour"
                      href      = {`/exercisehistory/${title}/${week_tracker}/${program_id}/${exercise_id}/${yt_id}`}
                      onClick   = {this.props.handleGenericClick}
                      style     = {{color: font_color}}>
                      <span className="workoutDetailsHistoryLinkGlyphIcon">
                          <span className="glyphicon glyphicon-signal"/>
                      </span>
                      History
                </span>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/LinkHistory.js